import React, { useCallback, useEffect, useState } from 'react'
import Modal from '../../Modal/Modal'
import { useToast } from '../../../../context/ToastContext'
import { Divider, ModalBody } from './NewsletterModal.styles'

const isUnsubscribed = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const unsubscribeSearchParam = searchParams.get('unsubscribe')
  const emailSearchParam = searchParams.get('email')
  const resubscribeSearchParam = searchParams.get('resubscribe')

  return {
    isUnsubscribed: !!(
      resubscribeSearchParam &&
      unsubscribeSearchParam &&
      unsubscribeSearchParam === 'true' &&
      emailSearchParam
    ),
    resubscribeLink: resubscribeSearchParam,
  }
}

function NewsletterModal() {
  const [loading, setLoading] = useState(false)
  const { showToast } = useToast()
  const [modalNewsletter, setModalNewsletter] = useState(() => {
    if (typeof window !== 'undefined') {
      return isUnsubscribed().isUnsubscribed
    }

    return false
  })
  const [resubscribeLink, setResubscribeLink] = useState(() => {
    if (typeof window !== 'undefined') {
      return isUnsubscribed().resubscribeLink
    }

    return false
  })

  const onCloseModal = () => {
    setModalNewsletter(false)
  }

  useEffect(() => {
    const isSubscribed = isUnsubscribed()

    setResubscribeLink(isSubscribed.resubscribeLink)
    setModalNewsletter(isSubscribed.isUnsubscribed)
  }, [])

  const onUnsubscribe = useCallback(() => {
    showToast('Newsletter subscribe', 'You have successfully unsubscribed from the newsletter..')

    onCloseModal()
  }, [onCloseModal])

  const onKeepSubscribed = useCallback(() => {
    setLoading(true)
    const link = document.createElement('a')
    link.href = resubscribeLink
    link.target = '_blank'
    link.click()

    showToast('Newsletter resubscribe', 'You have successfully resubscribed to the newsletter..')

    // fetch(resubscribeLink)
    //   .then(() => {
    //     showToast("Newsletter resubscribe", "You have successfully resubscribed to the newsletter..")
    //   }).catch(err => {
    //   showToast("Newsletter resubscribe failed.", err?.message || "Unavailable reason")
    // }).finally(() => setLoading(false))

    setLoading(false)

    onCloseModal()
  }, [resubscribeLink, onCloseModal])

  return (
    <Modal
      title={'Unsubscribe from Emails'}
      subTitle=""
      isLoading={loading}
      isOpen={modalNewsletter}
      onClose={onUnsubscribe}
      onSecondaryButton={onKeepSubscribed}
      onSubmit={onUnsubscribe}
      primaryButtonText="Unsubscribe"
      secondaryButtonText="Keep me subscribed"
    >
      <ModalBody>
        <p>We're sorry to see you go!</p>
        <p>Are you sure you want to unsubscribe from our email notifications?</p>
        <Divider />
        <p>You’ll stop receiving:</p>
        <ul>
          <li>Product updates</li>
          <li>Special offers</li>
          <li>Helpful tips and news</li>
        </ul>
      </ModalBody>
    </Modal>
  )
}

export default NewsletterModal
